export default __webpack_public_path__ + "files/d6b99dfb97799e2a50cb93f840bec85a.jpg";